import { render, staticRenderFns } from "./creditNote.vue?vue&type=template&id=47df710c&"
import script from "./creditNote.vue?vue&type=script&lang=js&"
export * from "./creditNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports